import './gallery5050.scss'
import { RichText } from 'prismic-reactjs'
import linkResolver from '../../helpers/linkResolver'
import dynamic from 'next/dynamic'
const Image = dynamic(() => import('../elements/image'), { ssr: false, loading: () => null })

export default ({ items }) => {
  return (
    <section>
      <div className="article-gallery-fifty">
        {items.map((item, i) => {
          return (
            <div key={`gallery-fifty-item-${i}`} className="item">
              <Image className="picture" image={item.image} />
              <div className="description">{RichText.render(item.description, linkResolver)}</div>
            </div>
          )
        })}
      </div>
    </section>
  )
}
